import React, { useState, useRef, useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";

// Images
import WelcomeImg from "../../assets/images/WelcomeImg.png";
import img1 from "../../assets/images/Welcomeimg1.png";
import img2 from "../../assets/images/Welcomeimg2.png";
import img3 from "../../assets/images/Welcomeimg3.png";
import SwipeIcon from "../../assets/images/swipe-img.png";

const slides = [
  { image: WelcomeImg, text: "You're in the Testing Mode" },
  { image: img1, text: "Shop and ADD your parcel in TMW app" },
  { image: img2, text: "Delivery person will put parcel in your locker" },
  { image: img3, text: "Collect your parcel Effortlessly!" },
];

const WelcomeModal = ({ isOpen, onClose }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [dragX, setDragX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  // FULLY LOCK BACKGROUND SCROLL
  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
      document.body.style.overscrollBehavior = "none";
      document.documentElement.style.overflow = "hidden";
      document.documentElement.style.height = "100%";
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
      document.body.style.overscrollBehavior = "";
      document.documentElement.style.overflow = "";
      document.documentElement.style.height = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
      document.body.style.overscrollBehavior = "";
      document.documentElement.style.overflow = "";
      document.documentElement.style.height = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      onClose();
    }
  };

  const resetDrag = () => {
    setDragX(0);
    setIsDragging(false);
  };

  const completeSwipe = () => {
    if (currentSlide === 0 && dragX > 100) {
      setCurrentSlide(1);
    }
    resetDrag();
  };

  const handleStart = (clientX) => {
    if (currentSlide !== 0) return;
    setIsDragging(true);
  };

  const handleMove = (clientX) => {
    if (!isDragging || currentSlide !== 0 || !containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const maxDrag = rect.width - 80;
    const x = clientX - rect.left - 32;
    if (x >= -32 && x <= maxDrag) {
      setDragX(x);
    }
  };

  const handleEnd = () => {
    if (isDragging) completeSwipe();
  };

  return (
    <div 
      className="fixed inset-0 z-[9999] flex flex-col bg-white/70 backdrop-blur-[30px]"
      style={{ touchAction: "none" }}
    >
      {/* Main Content - 50% Purple Gap (Beautiful & Balanced) */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 pt-8 pb-12">
        <div className="w-full max-w-2xl text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black leading-tight mb-6 px-4">
            {slides[currentSlide].text}
          </h2>

          <div className="flex justify-center items-end">
            <img
              src={slides[currentSlide].image}
              alt={`Slide ${currentSlide + 1}`}
              className="max-w-full h-auto object-contain max-h-[52vh] drop-shadow-2xl"
            />
          </div>
        </div>
      </div>

      {/* Fixed Bottom Controls */}
      <div className="w-full px-4 pb-8 pt-4 bg-gradient-to-t from-white/90 to-transparent">
        <div className="max-w-xl mx-auto">

          {/* First Slide: Swipe Bar */}
          {currentSlide === 0 && (
            <div
              ref={containerRef}
              className="relative bg-[#007AFF] rounded-[14px] h-16 shadow-2xl overflow-hidden cursor-grab active:cursor-grabbing select-none"
              style={{ maxWidth: "449px", width: "100%", margin: "0 auto" }}
              onTouchStart={(e) => handleStart(e.touches[0].clientX)}
              onTouchMove={(e) => handleMove(e.touches[0].clientX)}
              onTouchEnd={handleEnd}
              onMouseDown={(e) => handleStart(e.clientX)}
              onMouseMove={(e) => handleMove(e.clientX)}
              onMouseUp={handleEnd}
              onMouseLeave={handleEnd}
            >
              <div className="absolute inset-0 bg-[#0066DD]/20 rounded-[14px]" />

              <div
                className="absolute top-1/2 -translate-y-1/2 pointer-events-none z-10"
                style={{
                  left: "10px",
                  transform: `translateX(${dragX}px) translateY(-50%)`,
                  transition: isDragging ? "none" : "transform 0.5s cubic-bezier(0.2, 0.8, 0.2, 1)",
                }}
              >
                <img src={SwipeIcon} alt="Swipe" className="w-12 h-12 object-contain drop-shadow-lg" />
              </div>

              <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-20">
                <span 
                  className="text-white font-normal text-center capitalize px-8"
                  style={{
                    fontFamily: "'Alata', sans-serif",
                    fontWeight: 400,
                    fontSize: 'clamp(17px, 4.5vw, 28px)',
                    lineHeight: '1.1',
                  }}
                >
                  Swipe to Proceed
                </span>
              </div>
            </div>
          )}

          {/* Other Slides */}
          {currentSlide > 0 && (
            <div className="flex justify-between items-center w-full max-w-md mx-auto px-2">
              <div className="flex gap-2">
                {[1, 2, 3].map((_, i) => (
                  <div
                    key={i}
                    className={`transition-all duration-300 rounded-full ${
                      currentSlide === i + 1
                        ? "bg-black w-7 h-1.5"
                        : "bg-gray-400 w-1.5 h-1.5"
                    }`}
                  />
                ))}
              </div>

              <button
                onClick={handleNext}
                className="flex items-center gap-2 bg-[#007AFF] hover:bg-[#0066DD] text-white font-medium px-5 py-2.5 rounded-[10px] text-sm shadow-xl active:scale-95 transition-all"
              >
                {currentSlide === slides.length - 1 ? "Start" : "Next"}
                <FaArrowRight className="text-lg" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;